import React from "react";

const WhiteJMJLogo = ({ className = "" }) => {
  return (
    <img
      src="https://jmjpc.org/wp-content/uploads/2023/12/JMJ-Logo-ai.svg"
      alt="JMJ Logo"
      className={`my-2 w-24 h-auto brightness-0 invert ${className}`}
    />
  );
};

export default WhiteJMJLogo;
